import React from "react";
import { ClipStatusViewModel } from "./ViewModel";
import { TrayShell } from "./Components/TrayShell";

export const ClipStatusTray = () => {
  const { entries, trayExpanded, toggleTray, dismissTerminal } =
    ClipStatusViewModel();

  return (
    <TrayShell
      entries={entries}
      expanded={trayExpanded}
      onToggleTray={toggleTray}
      onDismiss={dismissTerminal}
    />
  );
};
